module.exports = __webpack_public_path__ + "static/media/LeftArrow.71b0401e.svg";